import {
  Avatar,
  Button,
  Checkbox,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslate } from "../../../hooks/useTranslate";
import { IAnimal } from "../interface";

import image from "../../../assets/jpg/no_image.jpg";

interface IAnimalItem {
  animal: IAnimal;
  checked: boolean;
  onChange: (batch: IAnimal, checked: boolean) => void;
}

export const AnimalItem: React.FC<IAnimalItem> = ({
  animal,
  checked,
  onChange,
}) => {
  const { translate } = useTranslate();
  return (
    <Paper
      component={Button}
      sx={{ py: 1, px: 2, bgcolor: "grey.50" }}
      elevation={0}
      onClick={(_) => {
        onChange(animal, !checked);
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item md={false}>
          <Avatar src={animal?.photo ?? image} alt={animal.name} />
        </Grid>
        <Grid item md>
          <Stack sx={{ textAlign: "left" }}>
            <Typography>
              #{animal.number_identifier} <strong>{animal.name}</strong>
            </Typography>
            <Typography variant="caption">
              {`${translate(`animals.${animal.gender}`)} / ${translate(
                "animals.placeholder_batch"
              )}: ${
                animal.batch?.name ?? translate("global.uninformed")
              } / ${translate("animals.placeholder_flock")}: ${
                animal.flock?.name ?? translate("global.uninformed")
              }`}
            </Typography>
          </Stack>
        </Grid>
        <Grid item md={false}>
          <Checkbox checked={checked} />
        </Grid>
      </Grid>
    </Paper>
  );
};
